document.addEventListener("DOMContentLoaded", function() {
  const closeButton = document.querySelector(".menu-drawer__close-button");
  const anchorLinks = document.querySelectorAll('.menu-drawer__menu-item[href*="/#"]');
  anchorLinks.forEach(link => {
    link.addEventListener("click", function() {
      if (closeButton) {
        closeButton.click();
      }
    });
  });

  const select = document.querySelector('select[name="options[Gloves size]"]');
  if (!select) return;
  select.value = '';

  document.addEventListener('change', function (e) {
    if (e.target.name !== 'options[Gloves size]') return;

    const btn = document.querySelector('button[name="add"]');
    if (!btn) return;

    if (!btn.hasAttribute('on:click')) {
      btn.setAttribute('on:click', '/handleClick');
    }

    btn.disabled = !e.target.value;
  });

  const sizeSelect = document.querySelector('select[name="options[Gloves size]"]');
  const addBtn = document.querySelector('button[name="add"]');
  const error = document.querySelector('.gloves-size-error');

  if (!sizeSelect || !addBtn) return;

  addBtn.addEventListener('click', (e) => {
    // Sold out → do nothing (button is actually disabled)
    if (addBtn.disabled) return;

    // Gloves size not selected
    if (!sizeSelect.value) {
      e.preventDefault();
      error?.classList.remove('hidden');
      sizeSelect.focus();
      return;
    }

    // Valid
    error?.classList.add('hidden');
  });

  sizeSelect.addEventListener('change', () => {
    if (sizeSelect.value) {
      addBtn.removeAttribute('data-force-disabled');
      addBtn.removeAttribute('aria-disabled');
      error?.classList.add('hidden');
    } else {
      addBtn.setAttribute('data-force-disabled', 'true');
      addBtn.setAttribute('aria-disabled', 'true');
    }
  });

});